import React from 'react';

const Ellipse1758 = props => (
  <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="4" cy="4" r="4" fill="#2A5595" />
  </svg>
);

export default Ellipse1758;
